export default "__VITE_ASSET__Dm26l2mR__"